import {
  despawnBlockEntity,
  SpiderBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { SpiderFallAnimation } from '../../animations/SpiderFallAnimation';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';

export type SpiderEffectOptions = {
  entity: SpiderBlockEntity;
};

export class SpiderFallEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: SpiderEffectOptions;

  constructor(scene: GameScene, options: SpiderEffectOptions) {
    this.scene = scene;
    this.options = options;
  }

  public static assets(): string[] {
    return [];
  }

  public async execute() {
    const entity = this.options.entity;
    const position = entity.c.position.mapPosition;
    const scale = entity.c.blockSpider.view.movieclip.style.scale;

    // create animation
    const animation = new SpiderFallAnimation({ scale });

    // spawn animation as overlay
    const animationEntity = spawnOverlayEntity(
      this.scene,
      position,
      {},
      () => animation,
      'foreground',
    );

    // despawn spider entity instantly
    despawnBlockEntity(this.scene, entity);

    // run animation
    await animation.start();

    // despawn animation
    despawnOverlayEntity(this.scene, animationEntity);
  }
}
